var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFourthBoxMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 560,
    viewBox: "0 0 344 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4550_71307)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4550_71307)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 38.2061,
    width: 312,
    height: 163.854,
    fill: "black",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 38,
    width: 312,
    height: 510,
    fill: "url(#paint0_linear_4550_71307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5455 20H321.455L328 38H16L22.5455 20Z",
    fill: "url(#paint1_linear_4550_71307)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4550_71307",
    x: 0,
    y: 0,
    width: 344,
    height: 560,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4550_71307"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4550_71307",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4550_71307",
    x: 6.9,
    y: 29.1061,
    width: 330.2,
    height: 182.054,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.55,
    result: "effect1_foregroundBlur_4550_71307"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4550_71307",
    x1: 16,
    y1: 293,
    x2: 328,
    y2: 293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFDDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDBD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4550_71307",
    x1: 16,
    y1: 29,
    x2: 328,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5EDEA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFourthBoxMobile);
export default __webpack_public_path__ + "static/media/ic-fourth-box-mobile.3babb726c73a8c82db37b783eae8c8d9.svg";
export { ForwardRef as ReactComponent };